import React from 'react';
import {
  FormValuesContextType,
  FocusContextType,
  PageProps,
  SuggestedPlaceDetailsContextType,
  SelectDestinationNameContextType,
} from './index.types';

export const ViewportContext = React.createContext(false);
export const ContentContext = React.createContext<PageProps>({
  findHotelLabel: '',
  placeholderTextDesktop: '',
  placeholderTextMobile: '',
  isItForOffersPage: '',
  hideDestination: '',
  submitAction: '',
  showDatesOnMobile: '',
  ratesShopPageHeader: '',
  enableTwoBoxForHeaderDates: '',
  maxGuestPerRoom: '',
  disableRecentlyViewed: '',
  topDestinationslistItems: [],
  dateFormat: '',
  alternateDateFormat: '',
  enableFlexibleSearch: '',
  maxChildAge: '',
  hpBulkSearchEndPoint: '',
  disableTopDestination: '',
  enableRedeemPoints: '',
  localDateFormat: '',
  searchViewType: '',
  disableFloatingBehavior: '',
  orderingRecentlySearchedAndViewed: '',
  specialRatesListItems: [],
  hideFlexibleDatesCheckbox: '',
  enablePadding: '',
  src: '',
  placeholderTextPopularDestination: '',
  domesticDestinationsListItems: [],
  enableMarriottShopPage: '',
  enableOverlap: '',
  maxNumberOfNights: '',
  enableNewSearch: '',
  hpSearchEndPoint: '',
  roomListItems: [],
  submitActioPrefix: '',
  firstDayOfWeek: '',
  featuredDestinationsListItems: [],
  disableRecentlySearched: '',
  destination: '',
  checkInLabel: '',
  checkOutLabel: '',
  currentLocationLabel: '',
  exactDatesTabText: '',
  flexibleTabText: '',
  howManyNights: '',
  roomsGuestsHead: '',
  rooms: '',
  room: '',
  guests: '',
  guest: '',
  adults: '',
  children: '',
  dates: '',
  ageBasedRatesLabel: '',
  childAgeRequired: '',
  reset: '',
  selectOneRateLabel: '',
  usePointsCertificates: '',
  disableUsePointCertificates: false,
  datesPlaceholderText: '',
  clear: '',
  flexibleDates: '',
  myDatesFlexibleLabel: '',
  currentLocationText: '',
  add: '',
  remove: '',
  cancel: '',
  night: '',
  nights: '',
  done: '',
  clearLabel: '',
  destinationSearchResult: '',
  flexible: '',
  recentSearchesHeading: '',
  recentlyViewedHeading: '',
  clearRecentLabel: '',
  lessThanLabel: '',
  ageLabel: '',
  applyLabel: '',
  specialRatesPoints: '',
  edit: '',
  addCorpOrPromoCode: '',
  usePointsConfirmMessage: '',
  flexibleAlertMessage: '',
  stayDates: '',
  noResultFound: '',
  weekdays: '',
  weekdaysLong: '',
  months: '',
  selectAMonth: '',
  storefrontPropertySearchWidgetErrorMessageRooms: '',
  collapseLabel: '',
  newSearchLabel: '',
  weekdaysShort: '',
  monthsShort: '',
  domesticLabel: '',
  featuredLabel: '',
  collapseOnPageLoad: false,
  collapseWhenUserUpdates: false,
  nightCountDecreaseLabel: '',
  nightCountIncreaseLabel: '',
  disableHotelHeaderAndReviewLinks: false,
  disableHotelReviewLinks: false,
  yearLabel: '',
  yearSearchLabel: '',
});

// FocusContext is to check if curent component should be on focus
export const FocusContext = React.createContext<FocusContextType>({
  focusComp: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setFocusComp: () => {},
  isUserInteractWithComp: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsUserInteractWithComp: () => {}, //search page handle user interactions
  isUserEditSearchForm: false, //if user is actively edited the form
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsUserEditSearchForm: () => {},

  isUpdateSearchClicked: false, //if user click on update search button
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsUpdateSearchClicked: () => {},
});

export const FormValuesContext = React.createContext<FormValuesContextType>({
  UUID: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setFormValues: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUUID: () => {},
  lastActiveState: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsPopupOpen: () => {},
});

//SuggestedPlaceDetailsContext is used to wait for suggestedPlaceDetails call to respond before calling rates api
export const SuggestedPlaceDetailsContext = React.createContext<SuggestedPlaceDetailsContextType>({
  suggestedPlaceDetailsCallDone: true,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSuggestedPlaceDetailsCallDone: () => {},
});

export const SelectDestinationNameContext = React.createContext<SelectDestinationNameContextType>({
  isAutoSuggestSelected: false,
  setIsAutoSuggestSelected: () => {
    //TODO : empty function
  },
  isRecentSearchSelected: false,
  setIsRecentSearchSelected: () => {
    //TODO : empty function
  },
});
